import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["pageSizeSelect"];

  updateResults() {
    if (this.hasPageSizeSelectTarget) {
      const form = this.pageSizeSelectTarget.form;
      if (form) {
        form.submit();
      } else {
        console.warn("Form not found to submit and update results");
      }
    }
  }
}
